import CustomButton from "Components/Custom/CustomButton";
import { useFormik } from "formik";
import React from "react";
import {
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import * as Yup from "yup";

interface DiscountModalProps {
  openDiscountModal: boolean;
  toggleDiscountModal: () => void;
  discountPercentage: number; // REQUIRED
  addDiscount: (percentage: number) => void;
}

interface DiscountType {
  discountPercentage: number;
}

const DiscountModal: React.FC<DiscountModalProps> = ({
  openDiscountModal,
  toggleDiscountModal,

  discountPercentage,
  addDiscount,
}) => {
  const validation = useFormik<DiscountType>({
    enableReinitialize: true,
    initialValues: {
      discountPercentage: discountPercentage,
    },
    validationSchema: Yup.object({
      discountPercentage: Yup.number()
        .typeError("Discount Percentage must be a number")
        .required("Discount Percentage is required")
        .integer("Discount Percentage must be a whole number")
        .min(0, "Discount Percentage must be at least 0")
        .max(100, "Discount Percentage cannot exceed 100%")
        .test(
          "decimal-places",
          "Discount Percentage can have up to 2 decimal places",
          (value) => {
            if (value === undefined || value === null) return true;
            return /^\d+(\.\d{1,2})?$/.test(value.toString());
          }
        ),
    }),
    onSubmit: (values) => {
      addDiscount(
        Number(values.discountPercentage.toString().replace(/^0+(?=\d)/, ""))
      );

      validation.resetForm();
    },
  });

  return (
    <Modal
      isOpen={openDiscountModal}
      toggle={() => {
        toggleDiscountModal();
        validation.resetForm();
      }}
      centered
      contentClassName="br-8"
    >
      <ModalHeader
        className="bg-greyF5 p-3 bg-light"
        toggle={() => {
          toggleDiscountModal();
          validation.resetForm();
        }}
      >
        Add Discount
      </ModalHeader>
      <form
        className="h-100  d-flex flex-column justify-content-between"
        onSubmit={(e) => {
          e.preventDefault();
          validation.handleSubmit();
        }}
      >
        <ModalBody className=" p-3">
          <div className="w-100">
            <div className="mb-3">
              <Label
                className="form-label"
                htmlFor="product-title-input text-start"
              >
                Discount (in {discountPercentage}%)
              </Label>
              <Input
                type="text"
                className="form-control"
                id="product-title-input"
                placeholder="e.g. 20"
                name="discountPercentage"
                value={validation.values.discountPercentage}
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                invalid={
                  !!validation.touched.discountPercentage &&
                  !!validation.errors.discountPercentage
                }
              />
              {validation.touched.discountPercentage &&
                validation.errors.discountPercentage && (
                  <FormFeedback>
                    {validation.errors.discountPercentage}
                  </FormFeedback>
                )}
            </div>
            <div className="d-flex align-items-start justify-content-between w-100 pt-4 mt-4 border-top border-top border-top-dashed">
              <CustomButton
                type="submit"
                text="Apply Discount"
                className="bg-primary br-7"
              />
            </div>
          </div>
        </ModalBody>
      </form>
    </Modal>
  );
};

export default DiscountModal;
